import { computed } from 'vue'
import type { SiteConfig } from '@/types'
import { baseConfig, mergeSiteConfig, siteConfig as staticSiteConfig } from '@/config'
import { fallbackData } from './fallbacks'
import { useJsonResource } from './useJsonResource'

const fallbackSiteConfig: SiteConfig = mergeSiteConfig(
  baseConfig,
  staticSiteConfig ?? fallbackData.siteConfig as Partial<SiteConfig>
)

const loader = useJsonResource<SiteConfig>('siteConfig', fallbackSiteConfig, {
  map: value => mergeSiteConfig(fallbackSiteConfig, value as Partial<SiteConfig>)
})

export function useSiteConfig() {
  const siteConfig = computed<SiteConfig>(() => loader.data.value ?? fallbackSiteConfig)
  return {
    siteConfig,
    loading: loader.loading,
    error: loader.error,
    refresh: loader.refresh
  }
}
